/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/ChangeAppointmentType/Content/AppointmentTypes/Content",
  onChange
  
}) {
let appointmentTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'appointment_templates',
})
let changeAppointmentTypeAppointmentTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'change_appointment_type',
path: 'appointment_type_id',
})
let changeAppointmentTypeAppointmentTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'change_appointment_type',
path: 'appointment_type_id',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 marginTop={dtSpaceM}
 data="appointment_templates"
 from={appointmentTemplatesValueData}
 data="change_appointment_type.appointment_type_id"
 value={changeAppointmentTypeAppointmentTypeIdValueData}
 onChange={changeAppointmentTypeAppointmentTypeIdChangeData}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Appointment type"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
</div>
{children}
</React.Fragment>)
}